import i18next from 'i18next';
import React from 'react';

import { Dropdown } from '@commons/utils/styledLibraryComponents';
import { PeriodDatePicker } from '@commons/DatePickers/PeriodDatePicker';
import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import { get } from 'lodash';
import {
  PeriodDatePickerContainer,
  LabelContainer,
  LabelRequiredCharacter,
  PeriodDatePickerAndLabelContainer,
} from './styledComponents';

const ExportModalWithStoresAndPeriod = (props) => {
  const {
    // Handle stores
    filteredStores,
    selectedStores,
    setSelectedStores,
    isUniqueStoreSelection = false,
    // Handle groups
    groups,
    selectedGroups,
    setSelectedGroups,
    // Handle date period
    periodPickerState,
    maxPastDate,
    maxFutureDate,
    defaultTimezone,
    clientStoreName,
  } = props;

  return (
    <>
      <Dropdown
        customStyle={{ position: 'inherit', height: '68px' }} // for the list to appear over the modal (instead of inside)
        iconSrc="/images/inpulse/pin-black-small.svg"
        isUniqueSelection={isUniqueStoreSelection}
        items={filteredStores}
        label={`${clientStoreName} :`}
        searchPlaceholder={i18next.t('GENERAL.SEARCH')}
        selectedItem={isUniqueStoreSelection && get(selectedStores, '[0]', null)}
        selectedItems={selectedStores}
        isRequired
        onSelectionChange={setSelectedStores}
      />
      <Dropdown
        customStyle={{ position: 'inherit', height: '68px' }} // for the list to appear over the modal (instead of inside)
        iconSrc="/images/inpulse/group-black-small.svg"
        isUniqueSelection={false}
        items={groups}
        label={`${i18next.t('GENERAL.GROUPS')} :`}
        searchPlaceholder={i18next.t('GENERAL.SEARCH')}
        selectedItems={selectedGroups}
        isRequired
        onSelectionChange={setSelectedGroups}
      />
      <PeriodDatePickerAndLabelContainer>
        <LabelContainer>
          <LabelRequiredCharacter>*</LabelRequiredCharacter>
          <Text
            color={ENUM_COLORS.DARKEST}
            font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}
            style={{ display: 'flex', alignItems: 'center' }}
          >
            {`${i18next.t('GENERAL.EXPORT_PERIOD')} :`}
          </Text>
        </LabelContainer>
        <PeriodDatePickerContainer>
          <PeriodDatePicker
            customStyle={{ position: 'absolute' }} // for the list to appear over the modal (instead of inside)
            disabled={false}
            endDate={periodPickerState.endDate}
            focusedDateInput={periodPickerState.focusedDateInput}
            maxFutureDate={maxFutureDate}
            maxPastDate={maxPastDate}
            setFocusedDateInput={periodPickerState.setFocusedDateInput}
            startDate={periodPickerState.startDate}
            timezone={defaultTimezone}
            onDatesChange={periodPickerState.handleSelectedDates}
          />
        </PeriodDatePickerContainer>
      </PeriodDatePickerAndLabelContainer>
    </>
  );
};

export default ExportModalWithStoresAndPeriod;
